import React from 'react';
import { Popover, Switch } from 'antd';
import { css } from '@emotion/core';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { PlansContainer, MySubContainer, SelectLabel } from './styled';
import { fontSize } from '../../../constants';
import IconSvg from '../../common/IconSvg';
import CourseModalAddOn from './CourseModalAddOn';

const SubscriptionAddonSwitch = ({ onSwitch, checked, isActive, name, popContent, cost }) => {
  return (
    <Popover
      content={
        isActive ? <FormattedMessage id="subscription.addonAlreadySubscribed" /> : popContent
      }
      title=""
      trigger="hover"
    >
      <div
        css={css`
          margin-right: 20px;
          h2 {
            display: inline;
            vertical-align: middle;
            margin-left: 10px;
          }
        `}
      >
        {isActive ? (
          <IconSvg type="v-green" size={22} marginLeft="22px" />
        ) : (
          <Switch onChange={onSwitch} checked={checked} />
        )}
        {isActive ? (
          <h2>{name}</h2>
        ) : (
          <h2>
            {cost} $ - {name}{' '}
          </h2>
        )}
      </div>
    </Popover>
  );
};

// @inject('settingsStore')
const SubscriptionAddons = ({
  subscriptionClone: { activePlan, toggleAddOn, addOnById },
  intl: { messages },
  // real info
  activeAddOnsMap,
  updateApplyBtn,
}) => {
  const conversionAddOns = activePlan?.allowedAddOnPlans?.filter(x => x.id !== 'course');
  // const courseAddOns = activePlan?.allowedAddOnPlans?.filter(x => x.id === 'course');
  return (
    <PlansContainer
      css={css`
        margin-top: 10px;
        > div {
          display: flex;
        }
        h2 {
          font-size: ${fontSize.medium};
          cursor: default;
        }
      `}
    >
      <MySubContainer>
        <SelectLabel>CONVERSION ADDON</SelectLabel>
        <div css={css`display:flex; margin-top:10px;`}>
          {(conversionAddOns ?? []).map(({ typeId, id, isSelected, name, cost }) => (
            <SubscriptionAddonSwitch
              key={`${typeId}-${id}`}
              onSwitch={e => {
                if (e && addOnById(id)?.isSelected) {
                  (addOnById(id)?.plans ?? []).forEach(el => {
                    toggleAddOn(false, el.id);
                  });
                }
                toggleAddOn(e, id);
                updateApplyBtn();
              }}
              checked={isSelected}
              isActive={activeAddOnsMap[id]}
              name={name}
              cost={cost}
              popContent={
                messages[`subscription.addonMessage_${typeId}`] ? (
                  <FormattedMessage id={`subscription.addonMessage_${typeId}`} />
                ) : (
                  name
                )
              }
            />
          ))}
        </div>
      </MySubContainer>
      <CourseModalAddOn />
    </PlansContainer>
  );
};

SubscriptionAddons.propTypes = {
  updateApplyBtn: PropTypes.func,
  subscriptionClone: PropTypes.object,
  activeAddOnsMap: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(observer(SubscriptionAddons));
